import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  MenuItem,
  Paper,
  FormControl,
  Select,
  InputLabel,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Header from "./Header";
import { Rate } from "rsuite";
import { Link } from "react-router-dom";
import { dateDifference, formatDateText } from "./CommonFunctions";
import axios from "axios";



export default function CleaningReport() {
  const [roomFilter, setRoomFilter] = useState("");
  const [assignedToFilter, setAssignedToFilter] = useState("");
  const [rows, setRows] = useState([]);
  const [statusFilter, setStatusFilter] = useState("");
  const [cleaningRecords, setCleaningRecords] = useState([]);
  const url = process.env.REACT_APP_SERVER_URL;


  useEffect(()=>{
    getCleaningRecordsInDB();

  },[]);

  useEffect(() => {
    // In real case, filter on the backend
    const filtered = cleaningRecords.filter((item) => {
    return (
        (roomFilter === "" || item.roomNumber.toLowerCase().includes(roomFilter.toLowerCase())) &&
        (assignedToFilter === "" || item.assignedto.toLowerCase().includes(assignedToFilter.toLowerCase())) &&
        (statusFilter === "" || item.status.toLowerCase() === statusFilter.toLowerCase())
    );
    });
    setRows(filtered);

  }, [roomFilter, assignedToFilter, statusFilter]);

  const getCleaningRecordsInDB = async() => {
    try{
      const response = await axios.get(`${url}/cleaning`);
      // console.log(response.data)
      if(response && response.data){
        console.log(response.data)
        setCleaningRecords(response.data)
        setRows(response.data)
      }

    }catch(error){
      console.log(error);
    }
  }

  const columns = [
    // { field: "id", headerName: "Ticket no.", width: 70 },
    { field: "roomid", headerName: "Room", width: 100 },
    { field: "assignedto", headerName: "Cleaned By", width: 130 },
    { field: "status", headerName: "Status", width: 120 },
    {
      field: "scheduledDate",
      headerName: "Scheduled At",
      width: 150,
      renderCell:(params)=>{
                const currentRow=params.row;
                return currentRow.scheduledDate ? formatDateText(currentRow.scheduledDate) : null;       
                    
        }
    },
    {
      field: "completedDate",
      headerName: "Completed At",
      width: 150,
      renderCell:(params)=>{
              const currentRow=params.row;
              return currentRow.completedDate ? formatDateText(currentRow.completedDate) : null;       
                  
        }
    },
    {
        field: "days",
      headerName: "Days Open",
      width: 150,
    //   renderCell:(params)=>{
    //           const currentRow=params.row;
    //           return dateDifference(currentRow.createdAt,currentRow.completedDate ? currentRow.completedDate : new Date());       
                  
    //     }
    },
    {
      field: "description",
      headerName: "Description",
      flex: 2,
    },
    { field: 'managerRatingOnCleaning', headerName: 'Rating', width: 150, align: 'left' ,
          renderCell:(params)=>{
            const currentRow=params.row;
            return <Rate size="xs" style={{width:"100px"}} 
            value={currentRow.managerRatingOnCleaning} readOnly></Rate>        
        } },
        { field: 'actions', headerName: 'Actions', width: 100, align: 'left' ,
          renderCell:(params)=>{
            const currentRow=params.row;
            return  <Box display="flex" flexDirection="column" gap={0.5}>
                <Link >Edit</Link>
                <Link >Delete</Link>
            </Box>
    } },
    
    
  ];

  return (
    <>

    <Header/>
    <Paper elevation={3} sx={{ p: 3 }}>
      <Grid container alignItems="center" justifyContent="space-between" mb={2}>
        <Grid item xs={12} md={8} container spacing={2}>
  <Grid item xs={4}>
    <TextField
      label="Filter by Room Number"
      value={roomFilter}
      onChange={(e) => setRoomFilter(e.target.value)}
      size="small"
      fullWidth
      variant="outlined"
    />
  </Grid>
  <Grid item xs={4}>
    <TextField
      label="Filter by Person"
      value={assignedToFilter}
      onChange={(e) => setAssignedToFilter(e.target.value)}
      size="small"
      fullWidth
      variant="outlined"
    />
  </Grid>
  <Grid item xs={4}>
    <TextField
      select
      fullWidth
      label="Status"
      value={statusFilter}
      onChange={(e) => setStatusFilter(e.target.value)}
      size="small"
      variant="outlined"
    >
      <MenuItem value="">All</MenuItem>
      <MenuItem value="Pending">Pending</MenuItem>
      <MenuItem value="In Progress">In Progress</MenuItem>
      <MenuItem value="Completed">Completed</MenuItem>
    </TextField>
  </Grid>
</Grid>

        <Grid item>
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              // open modal to raise cleaning request
              console.log("Open Cleaning Modal");
            }}
          >
            Raise Cleaning Request
          </Button>
        </Grid>
      </Grid>

      <Box sx={{ height: 400, width: "100%" }}>
        <DataGrid
          rows={rows}
          columns={columns}
          pageSize={5}
          disableRowSelectionOnClick
        />
      </Box>
    </Paper>

    </>
  );
}
